export const getSsnInputProps = (options?: {
  showPlaceholder?: boolean;
  isValueProvided?: boolean;
}) => ({
  placeholder: options?.showPlaceholder
    ? options?.isValueProvided
      ? "•••••••••"
      : "SSN or ITIN"
    : undefined,
  mask: "999999999",
  autoComplete: "off",
  fsExclude: true
});
